import React from 'react';
import { Box, Typography, Container } from "@mui/material";

const Blog = () => (
  <Box className="blog-page">
    <Container>
      <Typography variant="h1" sx={{ marginBottom: "20px", }} >
      Blog
      </Typography>



    </Container>
  </Box>
);

export default Blog;
